module.exports = __webpack_public_path__ + "static/media/b-white.b7cd9280.svg";